import { styled } from '@mui/material';
import Iconify from 'src/components/iconify';
import { useLocales } from 'src/locales';
import { ActionIcon } from './ActionIcon';

type Props = {
  isActive: boolean;
  isEnabled: boolean;
  activeIcon: string;
  inactiveIcon: string;
  tooltip: string;
  onClick: () => void;
  hasPermission?: boolean;
  askPermission?: () => void;
};

export const HasPermissionActionIcon = ({
  tooltip,
  isActive,
  isEnabled,
  activeIcon,
  inactiveIcon,
  onClick,
  hasPermission = true,
  askPermission,
}: Props) => {
  const { translate } = useLocales();
  return (
    <StyledContainer>
      {!hasPermission && (
        <StyledAlert>
          <Iconify icon="tabler:alert-small" color="white" />
        </StyledAlert>
      )}
      <ActionIcon
        tooltip={
          hasPermission
            ? tooltip
            : translate('shared.labels.permission_required')
        }
        onClick={hasPermission ? onClick : askPermission!}
        isActive={isActive}
        isEnabled={isEnabled}
        inactiveIcon={inactiveIcon}
        activeIcon={activeIcon}
      />
    </StyledContainer>
  );
};

const StyledContainer = styled('div')(() => ({
  position: 'relative',
}));

const StyledAlert = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(-0.5),
  right: theme.spacing(-0.5),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 16,
  height: 16,
  borderRadius: '50%',
  backgroundColor: theme.palette.warning.main,
}));
